import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  //创建转库单
  moveStore: (data) => apiAxios('post', baseURL + '/wms.move.store', data),
  //合并转库单
  mergeMove: (data) => apiAxios('post', baseURL + '/wms.move.merge', data),
  //返回待装箱状态
  backToPending: (data) => apiAxios('post', baseURL + '/wms.move.backToPending', data),
  //批量取消转库单
  batchCancel: (data) => apiAxios('post', baseURL + '/wms.move.batchCancel', data),
  //转库单tab数量统计
  tabCount: (data) => apiAxios('post', baseURL + '/wms.move.tabCount', data),
  //转库单列表
  moveList: (data) => apiAxios('post', baseURL + '/wms.move.list', data),
  //转库单列表-(已装箱完成)
  listCompleteBoxs: (data) => apiAxios('post', baseURL + '/wms.move.listCompleteBoxs', data),
  //批量上架到长存库存
  batchUpToShelf: (data) => apiAxios('post', baseURL + '/wms.move.batchUpToShelf', data),
  //商品列表
  goodsList: (data) => apiAxios('post', baseURL + '/wms.move.goodsList', data),
  //开始打包
  startPacking: (data) => apiAxios('post', baseURL + '/wms.move.startPacking', data),
  //转库单详情
  moveDetail: (data) => apiAxios('post', baseURL + '/wms.move.detail', data),
  //详情-添加箱子
  addBox: (data) => apiAxios('post', baseURL + '/wms.move.addBox', data),
  //详情-删除箱子
  deleteBox: (data) => apiAxios('post', baseURL + '/wms.move.deleteBox', data),
  //详情-修改箱规
  updateBoxAttr: (data) => apiAxios('post', baseURL + '/wms.move.updateBoxAttr', data),
  //详情-箱子列表
  boxList: (data) => apiAxios('post', baseURL + '/wms.move.boxList', data),
  //详情-批量装箱预览
  intoBoxPreview: (data) => apiAxios('post', baseURL + '/wms.move.intoBoxPreview', data),
  //详情-批量装箱
  intoBox: (data) => apiAxios('post', baseURL + '/wms.move.intoBox', data),
  //详情-单箱装箱详情
  boxDetail: (data) => apiAxios('post', baseURL + '/wms.move.boxDetail', data),
  //详情-取消装箱
  outBox: (data) => apiAxios('post', baseURL + '/wms.move.outBox', data),
  //详情-移箱
  moveBoxGoods: (data) => apiAxios('post', baseURL + '/wms.move.moveBoxGoods', data),
  //详情-批量完成装箱
  batchCompleteBox: (data) => apiAxios('post', baseURL + '/wms.move.batchCompleteBox', data),
  //详情-批量取消装箱完成
  batchUncompleteBox: (data) => apiAxios('post', baseURL + '/wms.move.batchUncompleteBox', data),
  //详情-装箱完成提交给行政
  completePacking: (data) => apiAxios('post', baseURL + '/wms.move.completePacking', data),

  // v2  // 长存仓库接口
  // 配送单箱转直接装箱(入长存待行政)
  convertFreightToOrderBox: (data) => apiAxios('post', baseURL + '/porder.convertFreightToOrderBox', data),
  // 直接装箱转库-列表
  boxTransferList: (data) => apiAxios('post', baseURL + '/box.transfer.list', data),
  // 直接装箱转库-tab数量统计
  boxTransferTabCount: (data) => apiAxios('post', baseURL + '/box.transfer.tabCount', data),
  // 直接装箱转库-提出入长存
  applyToCharge: (data) => apiAxios('post', baseURL + '/box.transfer.applyToCharge', data),
  // 直接装箱转库-取消转库
  transferCancel: (data) => apiAxios('post', baseURL + '/box.transfer.cancel', data),
  // 直接装箱转库-提交给行政
  confirmToAdmin: (data) => apiAxios('post', baseURL + '/box.transfer.confirmToAdmin', data),
  // 直接装箱转库-上架长存
  shelfToCharge: (data) => apiAxios('post', baseURL + '/box.transfer.shelfToCharge', data),
  // 直接装箱转库-申请退回普通仓库
  returnToNormal: (data) => apiAxios('post', baseURL + '/box.transfer.applyReturnFromCharge', data),
  // 直接装箱转库-取消出库申请
  cancelOutbound: (data) => apiAxios('post', baseURL + '/box.transfer.cancelOutbound', data),
  // 直接装箱转库-长存取出  行政取出给配货
  takeOutForPick: (data) => apiAxios('post', baseURL + '/box.transfer.takeOutForPick', data),
  // 直接装箱转库-上架常规库位
  shelfToNormal: (data) => apiAxios('post', baseURL + '/box.transfer.shelfToNormal', data),
}